<template>
    <div class="d-flex flex-column h-100">
        <div class="meeting-calendar-toolbar">
            <div class="d-flex align-items-center justify-content-start">
                <button class="btn btn-outline-primary border-0 fw-semibold px-2 py-1 me-2" @click="goToday">
                    <i class="fa fa-calendar mr-1"></i> Today
                </button>
                <span class="cursor-pointer px-2" @click="goPrev">
                    <i class="fas fa-chevron-left date-change-icon cursor-pointer"></i>
                </span>
                <span class="black-text">{{ dateRangeLabel }}</span>
                <span class="cursor-pointer px-2" @click="goNext">
                    <i class="fas fa-chevron-right date-change-icon cursor-pointer"></i>
                </span>
            </div>

            <div class="d-flex align-items-center justify-content-end w-20">
                <select class="form-select px-2 py-1" v-model="selectedView" @change="changeView">
                    <option value="dayGridMonth">Month</option>
                    <option value="timeGridWeek">Week</option>
                    <option value="timeGridDay">Day</option>
                </select>

                <button type="button" class="btn btn-primary px-2 py-1 ms-3 text-nowrap" @click="handleNewEventClick">
                    New Event
                </button>
            </div>
        </div>
        <FullCalendar
            id="Meeting__Calendar"
            ref="meetingCalendar"
            class="h-100 w-100"
            :options="calendarOptions"
        ></FullCalendar>
    </div>
</template>

<script lang="ts" src="./MeetingCalendar.ts"></script>
<style src="./MeetingCalendar.scss"></style>
